<ul class="group-items {{group.key}}-active" data-active-group="{{group.key}}"></ul>